import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { LayoutDashboard, Minimize2, EyeOff } from "lucide-react";

export type CardDisplayMode = "full" | "compact" | "hidden";

interface CardDisplayToggleProps {
  mode: CardDisplayMode;
  onModeChange: (mode: CardDisplayMode) => void;
}

export const CardDisplayToggle = ({ mode, onModeChange }: CardDisplayToggleProps) => {
  return (
    <ToggleGroup 
      type="single" 
      value={mode} 
      onValueChange={(value) => value && onModeChange(value as CardDisplayMode)}
      className="bg-white/40 dark:bg-slate-900/40 backdrop-blur-md border border-white/10 dark:border-white/5 rounded-md"
    >
      <ToggleGroupItem value="full" aria-label="Full cards" size="sm">
        <LayoutDashboard className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="compact" aria-label="Compact cards" size="sm">
        <Minimize2 className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="hidden" aria-label="Hide cards" size="sm">
        <EyeOff className="h-4 w-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
};